import { render } from "./DetailsSummary.vue?vue&type=template&id=b3faec38"
import script from "./DetailsSummary.vue?vue&type=script&lang=js"
export * from "./DetailsSummary.vue?vue&type=script&lang=js"

import "./DetailsSummary.vue?vue&type=style&index=0&id=b3faec38&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__